// Events for the site's self-hosted Minilytics (script tag in index.html). They become dashboard metrics:
// room_created = a pairing that connected (counted once, by the initiator); file_transferred = a received file.
type Props = Record<string, string | number | boolean>;

declare global {
  interface Window { minilytics?: (cmd: "goal", name: string, props?: Props) => void }
}

/** Never throws: analytics must not break a transfer, and the script may be blocked. */
export function trackEvent(name: string, props?: Props) {
  try { window.minilytics?.("goal", name, props); } catch { /* Ignored. */ }
}
